export default __webpack_public_path__ + "static/bavoir-25e1c95f08c2c0262e8a2832d9bb1cf0.jpg";